import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchMeRecentRuns, type MeActiveRun, type MeRecentRunsGroup } from '../../lib/api';
import { queryKeys } from './queryKeys';

/**
 * group 미지정 시 전체(active+past)를 단일 키로 조회한다(이어쓰기 picker 등).
 * "active"/"past"를 주면 별도 queryKey로 분리 조회해 SSE 무효화를 그룹 단위로 스코핑할 수 있다.
 */
export const useMeRecentRuns = (
  token: string | null,
  group?: MeRecentRunsGroup,
  projectIds?: string[],
  options?: { enabled?: boolean; refetchOnWindowFocus?: boolean; isFavorite?: boolean; keepPreviousData?: boolean },
) => {
  const recentRunsKey =
    group || options?.isFavorite
      ? queryKeys.me.recentRunsByGroup(group ?? 'all', projectIds, { isFavorite: options?.isFavorite })
      : queryKeys.me.recentRuns;

  return useQuery<MeActiveRun[]>({
    queryKey: recentRunsKey,
    queryFn: () => fetchMeRecentRuns(token as string, group ?? 'all', projectIds, { isFavorite: options?.isFavorite }),
    enabled: Boolean(token) && (options?.enabled ?? true),
    placeholderData: options?.keepPreviousData === false ? undefined : keepPreviousData,
    refetchOnWindowFocus: options?.refetchOnWindowFocus,
    staleTime: options?.isFavorite ? 30_000 : group === 'past' ? 5 * 60_000 : 30_000,
    gcTime: options?.isFavorite ? 5 * 60_000 : group === 'past' ? 10 * 60_000 : 5 * 60_000,
  });
};
